import React, { useContext } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Layout } from 'antd';
const { Sider, Content } = Layout;

import BasePane from '@totem/components/BasePane';
import OrgLayoutContext from '@totem/components/orgManagement/layout/orgLayoutContext';
import AddressesContainer from '@totem/components/orgManagement/orgDetails/buildings/options/addressContainer';
import AddressTable from '@totem/components/orgManagement/orgDetails/buildings/options/addressTable';
import AddressSearchInput from '@totem/components/orgManagement/orgDetails/buildings/options/searchInput';
import CustomersContainer from '@totem/components/orgManagement/orgDetails/netSuiteKeys/options/customersContainer';
import CustomerTable from '@totem/components/orgManagement/orgDetails/netSuiteKeys/options/customerTable';
import SearchInput from '@totem/components/orgManagement/orgDetails/netSuiteKeys/options/searchInput';
import InternalUsersContainer from '@totem/components/orgManagement/orgDetails/users/options/internalUsersContainer';
import InternalUsersTable from '@totem/components/orgManagement/orgDetails/users/options/internalUsersTable';
import UserSearchInput from '@totem/components/orgManagement/orgDetails/users/options/searchInput';
import OrgTable from '@totem/components/orgManagement/orgTable';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import PrimaryContentPane from '@totem/components/ui_components/page/PrimaryContentPane';

const styles = {
  inset: {
    marginLeft: '20px',
    marginRight: '20px',
  },
};

const OrgManagementLayout = () => {
  const { drawerOpen, selectedDrawer, closeDrawer, openDrawer } =
    useContext(OrgLayoutContext);

  return (
    <DndProvider backend={HTML5Backend}>
      <Layout hasSider>
        <Content>
          <BasePane>
            <PrimaryContentPane>
              <div style={styles.inset}>
                <OrgTable />
              </div>
            </PrimaryContentPane>
          </BasePane>
        </Content>
        <Sider
          collapsed={!drawerOpen}
          onCollapse={(collapsed) => {
            if (collapsed) {
              closeDrawer();
            } else {
              openDrawer(selectedDrawer);
            }
          }}
          collapsible
          reverseArrow
          width={800}
        >
          {drawerOpen && (
            <IBTabs
              activeKey={selectedDrawer}
              tabBarStyle={{ display: 'none' }}
              items={[
                {
                  key: 'netSuiteKeys',
                  label: 'NetSuite Keys',
                  children: (
                    <CustomersContainer>
                      <div style={{ width: 800, padding: 16 }}>
                        <SearchInput />
                        <br />
                        <br />
                        <BasePane>
                          <CustomerTable />
                        </BasePane>
                      </div>
                    </CustomersContainer>
                  ),
                },
                {
                  key: 'buildings',
                  label: 'NetSuite Addresses',
                  children: (
                    <AddressesContainer>
                      <div style={{ width: 800, padding: 16 }}>
                        <AddressSearchInput />
                        <br />
                        <br />
                        <BasePane>
                          <AddressTable />
                        </BasePane>
                      </div>
                    </AddressesContainer>
                  ),
                },
                {
                  key: 'users',
                  label: 'Users',
                  children: (
                    <InternalUsersContainer>
                      <div style={{ width: 800, padding: 16 }}>
                        <UserSearchInput />
                        <br />
                        <br />
                        <BasePane>
                          <InternalUsersTable />
                        </BasePane>
                      </div>
                    </InternalUsersContainer>
                  ),
                },
              ]}
            />
          )}
        </Sider>
      </Layout>
    </DndProvider>
  );
};

export default OrgManagementLayout;
